var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgFigmaicon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 96,
    height: 96,
    viewBox: "0 0 96 96",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_982_4023)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M48 48C48 51.1826 49.2643 54.2348 51.5147 56.4853C53.7652 58.7357 56.8174 60 60 60C63.1826 60 66.2348 58.7357 68.4853 56.4853C70.7357 54.2348 72 51.1826 72 48C72 44.8174 70.7357 41.7652 68.4853 39.5147C66.2348 37.2643 63.1826 36 60 36C56.8174 36 53.7652 37.2643 51.5147 39.5147C49.2643 41.7652 48 44.8174 48 48Z",
    stroke: "#1E1E1E",
    strokeWidth: 8,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M24 24C24 20.8174 25.2643 17.7652 27.5147 15.5147C29.7652 13.2643 32.8174 12 36 12H60C63.1826 12 66.2348 13.2643 68.4853 15.5147C70.7357 17.7652 72 20.8174 72 24C72 27.1826 70.7357 30.2348 68.4853 32.4853C66.2348 34.7357 63.1826 36 60 36H36C32.8174 36 29.7652 34.7357 27.5147 32.4853C25.2643 30.2348 24 27.1826 24 24Z",
    stroke: "#1E1E1E",
    strokeWidth: 8,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M36 36C32.8174 36 29.7652 37.2643 27.5147 39.5147C25.2643 41.7652 24 44.8174 24 48C24 51.1826 25.2643 54.2348 27.5147 56.4853C29.7652 58.7357 32.8174 60 36 60M36 60H48M36 60C33.6266 60 31.3066 60.7038 29.3332 62.0224C27.3598 63.3409 25.8217 65.2151 24.9135 67.4078C24.0052 69.6005 23.7676 72.0133 24.2306 74.3411C24.6936 76.6689 25.8365 78.8071 27.5147 80.4853C29.193 82.1635 31.3311 83.3064 33.6589 83.7694C35.9867 84.2324 38.3995 83.9948 40.5922 83.0866C42.7849 82.1783 44.6591 80.6402 45.9776 78.6668C47.2962 76.6934 48 74.3734 48 72V12",
    stroke: "#1E1E1E",
    strokeWidth: 8,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_982_4023"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 96,
    height: 96,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgFigmaicon);
export default __webpack_public_path__ + "static/media/figmaicon.346dcf9eb6851c6a78d620e8f570e2c6.svg";
export { ForwardRef as ReactComponent };